var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from "../../I18N";

import { Icon } from "../../UI";
import { addReference, saveTargetRangedReference } from "../actions/referencesActions";
import { cancelTargetDocument } from "../actions/documentActions";

export class TargetDocumentHeader extends Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
  }

  save() {
    const { reference, connection } = this.props;
    const { targetRange, targetFile } = reference;
    return this.props.saveTargetRangedReference(connection.toJS(), targetRange, targetFile, (ref) => {
      this.props.addReference(ref, true);
    });
  }

  render() {
    const { targetDocument, reference } = this.props;
    const { targetRange } = reference;

    let className = 'btn btn-default hidden';

    if (targetDocument && targetRange) {
      className = 'btn btn-success';
    }

    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "relationship-steps is-fixed" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.props.cancelTargetDocument,
        className: "btn btn-default" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "arrow-left" }), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Back")), /*#__PURE__*/

      _jsx("h2", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Select target paragraph"), /*#__PURE__*/
      _jsx("small", {}, void 0, "3"))), /*#__PURE__*/


      _jsx("div", { className: "ContextMenu ContextMenu-center" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.save, className: className }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "save" }), /*#__PURE__*/
      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save"))))));





  }
}










function mapStateToProps({ documentViewer, connections }) {
  return {
    connection: connections.connection,
    reference: documentViewer.uiState.toJS().reference,
    targetDocument: documentViewer.targetDoc.get('_id')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    saveTargetRangedReference,
    cancelTargetDocument,
    addReference
  },
  dispatch);

}

export default connect(mapStateToProps, mapDispatchToProps)(TargetDocumentHeader);